// extracted by mini-css-extract-plugin
export default {"home_banner":"Banner_home_banner__caJ-y"};